export var prepareToSubmitForm = function (toUpload) {
    var data;
    if (Object.values(toUpload).some(function (value) { return value instanceof File; })) {
        data = new FormData();
        Object.keys(toUpload).forEach(function (key) {
            data.append(key, toUpload[key]);
        });
    }
    else {
        data = toUpload;
    }
    return data;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/prepareToSubmitForm.ts
// module id = 593
// module chunks = 0